import { render, staticRenderFns } from "./ImageCapturingComponent.vue?vue&type=template&id=85e1cd9a"
import script from "./ImageCapturingComponent.vue?vue&type=script&lang=js"
export * from "./ImageCapturingComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageCapturingComponent.vue?vue&type=style&index=0&id=85e1cd9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports